import React from 'react';
import SelectInput from "@/Shared/SelectInput";
import TextInput from "@/Shared/TextInput";
import DateInput from "@/Shared/DateInput";
import CustomRadio from "@/Shared/CustomRadio";
import TextArea from "@/Shared/TextArea";
import PermissionsGate from "@/Shared/PermissionsGate";

const CouponForm = ({data, errors, setData, merchants}) => {
  return (
    <div className="flex flex-wrap p-8 -mb-8 -mr-6">
      <SelectInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Merchant"
        name="merchant_id"
        errors={errors.merchant_id}
        value={data.merchant_id}
        onChange={e => setData('merchant_id', e.target.value)}
      >
        {merchants[0].map(({merchant_id, merchant_name}) => (
          <option key={merchant_id} value={merchant_id}>
            {merchant_name}
          </option>
        ))}
      </SelectInput>
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Code"
        name="code"
        type="text"
        errors={errors.code}
        value={data.code}
        onChange={e => setData('code', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6"
        label="Link"
        name="link"
        type="text"
        errors={errors.link}
        value={data.link}
        onChange={e => setData('link', e.target.value)}
      />
      <DateInput
        date={data.start_date}
        setDate={setData}
        valueName={'start_date'}
        label={'Start Date'}
        errors={errors.start_date}
      />
      <DateInput
        date={data.expire_date}
        setDate={setData}
        valueName={'expire_date'}
        label={'Expiration Date'}
        errors={errors.expire_date}
      />
      <TextInput
        className="w-full pb-8 pr-6"
        label="Source"
        name="source"
        type="text"
        errors={errors.source}
        value={data.source}
        onChange={e => setData('source', e.target.value)}
      />

      <PermissionsGate scopes={['crud-coupon']}>
        <CustomRadio
          label="Tested"
          name="ysnTested"
          errors={errors.ysnTested}
          checked={+data.ysnTested}
          onChange={e => setData('ysnTested', e.target.value)}
        />
        <CustomRadio
          label="Working"
          name="ysnWorking"
          errors={errors.ysnWorking}
          checked={+data.ysnWorking}
          onChange={e => setData('ysnWorking', e.target.value)}
        />
        <CustomRadio
          label="Deleted"
          name="ysnDeleted"
          errors={errors.ysnDeleted}
          checked={+data.ysnDeleted}
          onChange={e => setData('ysnDeleted', e.target.value)}
        />
      </PermissionsGate>
      <TextArea
        className="w-full pb-8 pr-6"
        label="Description"
        name="description"
        errors={errors.description}
        value={data.description}
        onChange={e => setData('description', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="Restrictions"
        name="restrictions"
        errors={errors.restrictions}
        value={data.restrictions}
        onChange={e => setData('restrictions', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="Additional Comments"
        name="internal_notes"
        errors={errors.internal_notes}
        value={data.internal_notes}
        onChange={e => setData('internal_notes', e.target.value)}
      />
    </div>
  );
};

export default CouponForm;
